import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { withLatestFrom, switchMap, catchError, of, map } from "rxjs";
import { SalesOrderClient } from "src/api-service";
import { selectSelectedCompany } from "../../user/user.selectors";
import { SalesOrderActions } from "./sales-order.actions";
import { normalizeError } from "../../app-store-error.types";

// **************************************************************************
// SALES ORDER DETAIL EFFECTS
// **************************************************************************

@Injectable()
export class SalesOrderEffects {
    private readonly actions$ = inject(Actions);
    private readonly store = inject(Store);
    private readonly salesOrderClient = inject(SalesOrderClient);

    loadSalesOrder$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SalesOrderActions.load),
            withLatestFrom(this.store.select(selectSelectedCompany)),
            switchMap(([{ orderNumber }, selectedCompany]) => {
                const companyId = selectedCompany?.id;
                if (!companyId) {
                    return of(
                        SalesOrderActions.loadFailure({
                            error: { message: "No company selected" },
                            toastKey: "SALES_ORDER.TOAST.LOAD_ERROR",
                        })
                    );
                }

                return this.salesOrderClient.getBcSalesOrder(companyId, orderNumber).pipe(
                    map(salesOrder =>
                        SalesOrderActions.loadSuccess({
                            salesOrder,
                            toastKey: "SALES_ORDER.TOAST.LOAD_SUCCESS",
                        })
                    ),
                    catchError(error =>
                        of(
                            SalesOrderActions.loadFailure({
                                error: normalizeError(error),
                                toastKey: "SALES_ORDER.TOAST.LOAD_ERROR",
                            })
                        )
                    )
                );
            })
        )
    );
}
